import { appstr } from "./appstr";
import { enumFieldType, kBlockedFieldTag } from "../constants";
import { ResolveFallback } from "./ResolveFallback";
import { FormatFieldValue, isBlockedField } from "./FormatFieldValue";
import { ConcatResult } from "../CoreApp/ConcatResult";

export function PopulateConcat(concatCache, dbObj, curDef, docRef, quoteValues, returnNumber) {
  //   var c = this.fConcatCache;
  var c = concatCache;
  var n = c.length;
  var s = [];
  var textMarker = [];

  for (var i = 0; i < n; i++) {
    var p = c[i];
    if (p[0] == "[") {
      var fieldName = p.substring(1);
      var fallback = fieldName.split("|");
      var m = fallback.length;
      var done = m == 0;
      var j = 0;
      var result = new ConcatResult();
      while (!done) {
        if (fallback[j]) ResolveFallback(result, dbObj, fallback[j], curDef, docRef);
        done =
          j++ >= m ||
          (result.fValue &&
            result.fValue != "" &&
            result.fValue != "[" + appstr("refnotfound") + "]");
      }

      // Display mode relies on FormatFieldValue to translate the sentinel; only
      // math/number mode needs the short-circuit return.
      if (returnNumber && isBlockedField(result.fValue)) {
        return kBlockedFieldTag;
      }

      if (result.fDef) {
        var isNumber = result.fDef.GetFieldType() == enumFieldType.number;
        if (isNumber && returnNumber) p = result.fValue;
        else p = FormatFieldValue(result.fValue, result.fDef);
        if (quoteValues && !isNumber) p = '"' + result.fValue + '"';
      } else p = result.fValue;

      textMarker.push(0);
    } else {
      var lp = p.length;
      var tmType = 1;
      if (p[lp - 1] == "(") tmType = 2;
      else if (p[0] == ")") tmType = 3;
      textMarker.push(tmType);
    }

    s.push(p);
  }

  var n = textMarker.length;
  var final = "";
  for (var i = 0; i < n; i++) {
    var tM = textMarker[i];
    switch (tM) {
      case 0:
        final += s[i];
        break;
      case 1:
        var priorBlank = final == "" && i > 0;
        var nextBlank = i + 1 != n && s[i + 1].length == 0;
        if (!priorBlank && !nextBlank) final += s[i];
        break;
      case 2: // Drop the '(' if next is blank
        var nextBlank = i + 1 != n && s[i + 1].length == 0;
        if (!nextBlank) final += s[i];
        break;
      case 3: // Drop the ')' if prior is blank
        var priorBlank = i - 1 != -1 && s[i - 1].length == 0;
        if (priorBlank) final += s[i].substring(1);
        else final += s[i];
        break;
    }
  }

  return final.trim();
}
